// extracted by mini-css-extract-plugin
export default {"heading":"Hy-z","corrected":"Iy-z","redirectVerbiageContainer":"Jy-z","redirectVerbiageText":"Ky-z"};